import './App.css';
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";

import OneDayToDoPrivacyPolicy from './pages/OneDayToDoPrivacyPolicy';
import DefaultPage from './pages/DefaultPage';
import PomodoroPrivacyPolicy from './pages/PomodoroPrivacyPolicy';
import ShieldVpnPrivacyPolicy from './pages/ShieldVpnPrivacyPolicy';
import AlphaPlayerPrivacyPolicy from './pages/AlphaPlayerPrivacyPolicy';
import HabbitRootTermAndConditions from './pages/habbitRoot/HabbitRootTermAndConditions';
import HabbitRootPrivacyPolicy from './pages/habbitRoot/HabbitRootPrivacyPolicy';
import PrivacyPolicy from './pages/admobDashboardPrcyPolicy';
import Privacytermsarrowtapaway from './pages/privacytermsarrowtapaway';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route exact path="/" element={<DefaultPage />} />
        <Route exact path="/oneDayToDoPrivacyPolicy" element={<OneDayToDoPrivacyPolicy />} />
        <Route exact path="/pomodoroPrivacyPolicy" element={<PomodoroPrivacyPolicy />} />
        <Route exact path="/alphaPlayerPrivacyPolicy" element={<AlphaPlayerPrivacyPolicy />} />
        <Route exact path="shieldVpnPrivacyPolicy" element={<ShieldVpnPrivacyPolicy />} />
        <Route exact path="/AlphaLauncherPrivacyPolicy" element={<AlphaPlayerPrivacyPolicy />} />
        <Route exact path="/HabbitRootTermAndConditions" element={<HabbitRootTermAndConditions />} />
        <Route exact path="/HabbitRootPrivacyPolicy" element={<HabbitRootPrivacyPolicy />} />
        <Route exact path="/AdmobDashboardPrivacyPolicy" element={<PrivacyPolicy/>} />
        <Route exact path="/Privacytermsarrowtapaway" element={<Privacytermsarrowtapaway/>} />
      </Routes>
    </HashRouter>


  );
}

export default App;
